import type { Category } from "../types";

export const getIconCategoryColor = (category: Category | "variable"): string => {
  switch (category) {
    case "choices":
      return "bg-surface-field-choices icon-field-choices";
    case "dateTime":
      return "bg-surface-field-date-time icon-field-date-time";
    case "layout":
      return "bg-surface-field-layout icon-field-layout";
    case "location":
      return "bg-surface-field-location icon-field-location";
    case "media":
      return "bg-surface-field-media icon-field-media";
    case "number":
      return "bg-surface-field-number icon-field-number";
    case "personalInfo":
      return "bg-surface-field-personal-info icon-field-personal-info";
    case "searchItems":
      return "bg-surface-field-search-items icon-field-search-items";
    case "subform":
      return "bg-surface-field-subform icon-field-subform";
    case "variable":
      return "bg-surface-field-personal-info icon-primary";
    case "textFields":
      return "bg-surface-field-text icon-field-text";
    case "unknown":
      return "bg-surface-subtle icon-primary";
  }
};
